  <h1 mat-dialog-title>{{ title }}</h1>
  <mat-dialog-content>
        <app-download [id]="downloadId"></app-download>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
        <button type="button" class="btn-save" mat-button mat-raised-button (click)="dialogRef.close(true)">OK</button>
        <button type="button" mat-button mat-raised-button (click)="dialogRef.close()">Cancel</button>
  </mat-dialog-actions>